<template>
  <div>
    <CommentEditor
                v-if="isAuditoria"
                field="indicesCpo"
                :comentarios="comentarios"
                :odonto="odonto"
    />
    <b-row class="mb-2">
      <b-col cols="1"><strong>D</strong></b-col>
      <b-col cols="2">
        <b-form-group label="C">
          <b-form-input type="number" min="0" v-model.number="D.C" disabled />
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="P">
          <b-form-input type="number" min="0" v-model.number="D.P" disabled />
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="O">
          <b-form-input type="number" min="0" v-model.number="D.O" disabled />
        </b-form-group>
      </b-col>
      <b-col cols="2" class="d-flex align-items-center">
        <h5><strong>Total: </strong> {{ totalD }}</h5>
      </b-col>
    </b-row>

    <hr />

    <b-row>
      <b-col cols="1"><strong>d</strong></b-col>
      <b-col cols="2">
        <b-form-group label="c">
          <b-form-input type="number" min="0" v-model.number="d.c" disabled />
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="e">
          <b-form-input type="number" min="0" v-model.number="d.e" disabled />
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="o">
          <b-form-input type="number" min="0" v-model.number="d.o" disabled />
        </b-form-group>
      </b-col>
      <b-col cols="2" class="d-flex align-items-center">
        <h5><strong>Total: </strong> {{ totald }}</h5>
      </b-col>
    </b-row>

    <hr />

    <b-row class="mt-1">
      <b-col>
        <label>Exámenes Complementarios:</label>
        <b-form-textarea v-model="examenesComplementarios" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BFormInput,
  BFormGroup,
  BFormTextarea,
} from "bootstrap-vue";
import { mapState } from "vuex";
import { anamnesisService } from "../../../atencionMedica/services";
import CommentEditor from "../../../atencionMedica/components/CommentEditor/CommentEditor.vue";

export default {
  name: "IndicesCpo",
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    CommentEditor
  },

  data() {
    return {
      odonto:true,
      comentarios:{},
      cargoEx:false,
      anamnesisService,
      seCargoCpoOriginal: false,
      yaInicializado: false,
      examenesComplementarios: "",
      itemsTablaInicial: null,
      totalD: null,
      totald: null,
      D: {
        C: 0,
        P: 0,
        O: 0,
      },
      d: {
        c: 0,
        e: 0,
        o: 0,
      },
    };
  },

  props: {
    indicesCpoRecibido: {
      type: Object,
      default: null,
    },
       exRecibido: {
      required:false,
      default: null,
    },
       isAuditoria: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      stDataSemiologia: (state) => state.atencionCita.semiologias?.semActual,
    }),
  },
  methods: {
    sumaValores(obj) {
      return Object.values(obj)
        .map((val) => Number(val) || 0)
        .reduce((sum, val) => sum + val, 0);
    },

    emitirDatos() {
      this.$emit("update-indices-cpo", {
        D: this.D,
        d: this.d,
        totalD: this.totalD,
        totald: this.totald
      });
    },
      emitirExamenesComplementarios(newVal) {
      this.$emit("update-examenes", newVal);
    },

    totalCazUnicos(itemsTabla) {
      // Usamos un Set para almacenar los números únicos con procedimiento 'caz'
      const numerosConCaz = new Set();

      itemsTabla.forEach((item) => {
        if (item.procedimiento === "caz" && !item.realizado) {
          numerosConCaz.add(item.number);
        }
      });

      return numerosConCaz.size;
    },
    totalRestaurados(itemsTabla) {
      // Usamos un Set para almacenar los números únicos con procedimiento 'caz'
      const numerosConCaz = new Set();

      itemsTabla.forEach((item) => {
        if (item.procedimiento === "caz" && item.realizado) {
          numerosConCaz.add(item.number);
        }
      });

      return numerosConCaz.size;
    },

    indicesCpoMapper(indices) {
      const indicesCPO = indices;
      this.totalD = indicesCPO.CPO.Total;
      this.totald = indicesCPO.ceo.Total;
      this.D.C = indicesCPO.CPO.C;
      this.D.P = indicesCPO.CPO.P;
      this.D.O = indicesCPO.CPO.O;
      this.d.c = indicesCPO.ceo.c;
      this.d.e = indicesCPO.ceo.e;
      this.d.o = indicesCPO.ceo.o;
    },

   async indicesCPO(odontograma) {
  let itemsTabla = odontograma?.data?.odontograma?.itemsTabla;

  if (itemsTabla && itemsTabla.length) {
    const cariesKeywords = ["caz"];
    const extraccionKeywords = ["ext"];
    const obturacionKeywords = ["restauracion", "caz"];

    const permanentesC = new Set();
    const permanentesP = new Set();
    const permanentesO = new Set();

    const temporalesC = new Set();
    const temporalesE = new Set();
    const temporalesO = new Set();

    // Agrupar procedimientos por número de pieza válido
    const piezasMap = new Map();

    itemsTabla.forEach((item) => {
      const num = Number(item.number);
      // Asegúrate de que sea un número válido
      if (!isNaN(num)) {
        if (!piezasMap.has(num)) {
          piezasMap.set(num, []);
        }
        piezasMap.get(num).push(item);
      }
    });

    // Evaluar por pieza, no por ítem
    piezasMap.forEach((procedimientos, num) => {
      const isPermanente = num >= 11 && num <= 48;

      let tieneCaries = false;
      let fueExtraido = false;
      let estaObturado = false;

      for (const item of procedimientos) {
        const procedimiento = item.procedimiento?.toLowerCase() || "";
        const realizado = !!item.fecha_realizacion;
        const encontrado = !!item.encontrado;

        // Prioridad: Caries sin tratar
        if (!encontrado) {
          tieneCaries = true;
        } else if (encontrado && extraccionKeywords.includes(procedimiento)) {
          fueExtraido = true;
        } else if (encontrado && !extraccionKeywords.includes(procedimiento) && obturacionKeywords.includes(procedimiento) ) {
          estaObturado = true;
        }
      }

      // Clasificar pieza según procedimiento prioritario
      if (tieneCaries) {
        isPermanente ? permanentesC.add(num) : temporalesC.add(num);
      } else if (fueExtraido) {
        isPermanente ? permanentesP.add(num) : temporalesE.add(num);
      } else if (estaObturado) {
        isPermanente ? permanentesO.add(num) : temporalesO.add(num);
      }
    });

    return {
      CPO: {
        C: permanentesC.size,
        P: permanentesP.size,
        O: permanentesO.size,
        Total: permanentesC.size + permanentesP.size + permanentesO.size,
        Numeros: {
          C: Array.from(permanentesC),
          P: Array.from(permanentesP),
          O: Array.from(permanentesO),
        },
      },
      ceo: {
        c: temporalesC.size,
        e: temporalesE.size,
        o: temporalesO.size,
        Total: temporalesC.size + temporalesE.size + temporalesO.size,
        Numeros: {
          c: Array.from(temporalesC),
          e: Array.from(temporalesE),
          o: Array.from(temporalesO),
        },
      },
    };
  }
}
  },

  watch: {

    exRecibido: {
      deep:true,
      immediate:true,
      handler(newValue){
        if(newValue && !this.cargoEx) {
          this.examenesComplementarios = newValue
          this.cargoEx = true
        }
      }
    },

    stDataSemiologia: {
      deep: true,
      immediate: true,
      async handler(newValue) {
        console.log("ENTRA 1");
        if (!this.seCargoCpoOriginal) {
          console.log("ENTRA 2");
          if (newValue && newValue.odontograma_id) {
            console.log("ENTRA 3");
            const odontograma = await anamnesisService.getOdontogramaById(
              newValue.odontograma_id
            );

            if (!odontograma) return;

            try {
              let parsedOdontograma = JSON.parse(odontograma);

              const indicesCPO = await this.indicesCPO(parsedOdontograma);

              if (!indicesCPO) return;

              this.indicesCpoMapper(indicesCPO);

              this.seCargoCpoOriginal = true;
            } catch (error) {
              console.log("OCURRIO ERROR CPO ORIGINAL", error);
            }
          } else {
            console.log("ENTRA 4");
            let odontograma_vuex = newValue;

            console.log("ODONTOGRAMA VUEX", odontograma_vuex);

            const indicesCPO = await this.indicesCPO(odontograma_vuex);

            if (!indicesCPO) return;

            this.indicesCpoMapper(indicesCPO);
          }
        }
      },
    },

    D: {
      handler() {
        this.emitirDatos();
      },
      deep: true,
    },
    d: {
      handler() {
        this.emitirDatos();
      },
      deep: true,
    },
    examenesComplementarios: {
      deep:true,
      immediate:true,
      handler(newValue){
        this.emitirExamenesComplementarios(newValue);
      }
      
    },
    // indicesCpoRecibido: {
    //   handler(newValue) {
    //     if (!this.yaInicializado) {
    //       if (!newValue) {
    //         this.emitirDatos(); // Emitir datos vacíos si no se recibe nada
    //       } else {
    //         this.D = newValue.D || { C: 0, P: 0, O: 0 };
    //         this.d = newValue.d || { c: 0, e: 0, o: 0 };
    //         this.examenesComplementarios =
    //           newValue.examenesComplementarios || "";
    //       }

    //       this.yaInicializado = true;
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
};
</script>
